import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/svg/bed-single.svg")